require('./bootstrap')

import Vue from 'vue';
import Vuetify from 'vuetify';
// import Moment from 'moment'
import store from '~/store';
import router from '~/router';
import { i18n } from '~/plugins';
import App from '~/components/App';
import '~/components';
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'babel-polyfill';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css';
import VeeValidate from 'vee-validate';
// import VueSocketIO from 'vue-socket.io'
import Print from 'vue-print-nb';

Vue.use(VeeValidate);
Vue.use(Print);

// mount with global
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    primary: '#9C1A1A',
    secundary: '#EB3131',
    accent: '#76D080',
    error: '#F44336',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false

// Vue.use(new VueSocketIO({
//   debug: false,
//   // connection: 'https://socket.jdg.net.ve:3000',
//   connection: 'http://localhost:3000',
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
//   // options: { path: '/my-app/' } // Optional options
// }))

new Vue({
  el: '#app',
  sockets: {
    connect: function () {
      console.log('socket connected')
    }
  },
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js